import { render, staticRenderFns } from "./StrIsoIcTetkikSoru.vue?vue&type=template&id=23406d6a"
import script from "./StrIsoIcTetkikSoru.vue?vue&type=script&lang=js"
export * from "./StrIsoIcTetkikSoru.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports